import { connect } from 'react-redux';

import {
  getAuthorizationGroups,
  getAuthorizationUpdatingGroup,
  isAuthorizationUpdatingGroup,
} from '../../../reducers/analyticsApp';
import GroupsModal from '../../../components/authorization/groups/GroupsModal';
import {
  cancelUpdateGroup,
  setGroupId,
  setGroupPermissions,
  updateGroup,
} from '../../../actions/authorization';
import { setErrorMessage } from '../../../actions/application';
import { getNotUniqGroupMessage } from '../../../utils/errors';

// если group.groupId пустая строка или group.permissions не пустой массив
const isOkDisabled = (group) =>
  group &&
  (group.groupId === '' || !Array.isArray(group.permissions) || group.permissions.length === 0);

const mapStateToProps = (state) => {
  const group = getAuthorizationUpdatingGroup(state);
  const disabled = isOkDisabled(group);

  return {
    group,
    disabled,
    groups: getAuthorizationGroups(state),
    updating: isAuthorizationUpdatingGroup(state),
  };
};

const mapDispatchToProps = {
  onClose: cancelUpdateGroup,
  onOk: updateGroup,
  onGroupIdChange: setGroupId,
  onGroupPermissionsChange: setGroupPermissions,
  setErrorMessage,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onOk: () => {
    const isGroupUniq = (stateProps.groups || [])
      .filter(({ uuid }) => uuid !== stateProps.group.uuid)
      .every(({ groupId }) => groupId !== stateProps.group.groupId);

    if (isGroupUniq) {
      dispatchProps.onOk(stateProps.group);
    } else {
      const notUniqErrorMessage = getNotUniqGroupMessage(stateProps.group?.groupId);
      dispatchProps.setErrorMessage(notUniqErrorMessage);
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(GroupsModal);
